import React from 'react';
import NewCustomer from '../containers/NewCustomer';
import CustomerSelect from '../../sale/containers/CustomerSelectContainer';

const SelectCustomer = () => (
  <div>
    <div className="c-label-new">Select client</div>
    <div className="o-flexbox">
      <div className="u-flex-1 u-pr-">
        <CustomerSelect square />
      </div>
      <NewCustomer />
    </div>
  </div>
);

export default SelectCustomer;
